export default __webpack_public_path__ + "static/media/pregnancy-frame.973a63b6.png";